import { updateActionState } from '../../../../../store/appStateSlice';

export default function next() {
  updateActionState('btnNext');
}
